import { render, staticRenderFns } from "./region.vue?vue&type=template&id=243160f6&scoped=true"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"
import style0 from "./region.vue?vue&type=style&index=0&id=243160f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243160f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243160f6')) {
      api.createRecord('243160f6', component.options)
    } else {
      api.reload('243160f6', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=243160f6&scoped=true", function () {
      api.rerender('243160f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/districtManagement/cmp/region.vue"
export default component.exports